import React from 'react';

import { Layout } from './modules/Layout/components';
import { ApplicationRoutes } from './router';

import 'react-owl-carousel2/lib/styles.css';
import './App.scss';

const App: React.FC = () => {
    return (
    <Layout>
      <ApplicationRoutes />
    </Layout>
    );
};

export default App;
